import React, { useEffect, useRef, useState } from "react";
import { YHDrawer } from "@/components/YhDrawer";
import { message, Tooltip } from "antd";
import { useLockFn } from "ahooks";
import { WriteoffTypeEnum } from "@/views/account/AccountTypes";
import Table, { ColumnsType } from "antd/lib/table";
import { IBillDetail } from "@/views/bill/BillTypes";
import { useMaintenanceModel } from "../maintenanceModel";
import { repairFormatNum } from "@/utils/utils";
import { useDictModel } from "@/views/base/dict/dictModel";
import { maintenanceService } from "../../maintenanceService";
import YhTootip from "@/components/YhTootip";
import { IMaintenanceDetail } from "../../maintenanceType";

export const AllSettleDrawer = () => {

    const {
        selectedRowKeys,
        loadData,
        dataSource,
        allSettleDrawerVisible,
        setAllSettleDrawerVisible
    } = useMaintenanceModel();
    const [descRows, setDescRows] = useState<any>([]);
    const { getTreeNodeName } = useDictModel();
    useEffect(() => {
        setDescRows(dataSource.filter((item: any) => selectedRowKeys.includes(item.id)))
    }, [allSettleDrawerVisible])
    const columns: ColumnsType<IMaintenanceDetail> = [
        {
            title: '序号',
            width: 80,
            fixed: "left",
            align: "center",
            render: (t, r, i) => i + 1
        }, {
            align: "center",
            title: '工单单号',
            width: 150,
            dataIndex: "maintenanceCode",
            render: (text: any) => <YhTootip text={text} />,
        },
        {
            align: "center",
            title: '客户名称',
            dataIndex: "customerName",
            render: (text: any) => <YhTootip text={text} />,
        },
        {
            title: '结算类型',
            width: 100,
            dataIndex: 'payType',
            align: "center",
            render: (text: any) => getTreeNodeName(text),
        },
        // {
        //     align: "center",
        //     title: '账户实体',
        //     dataIndex: "beName"
        // },
        {
            // title: '应收金额',
            title: '营业额',
            width: 130,
            align: "center",
            dataIndex: 'receivableTotalAmount',
            render: (text) => `￥${repairFormatNum(text)}`
        },
    ]
    const onOk = useLockFn(async () => {
        try {
            const reqData = {
                mainSettleVoList: descRows.map((item: any) => {
                    return {
                        id: item.id,
                        maintenanceCode: item.maintenanceCode
                    }
                })
            };
            let insertRet: any = await maintenanceService.ALLsettle(reqData);
            message.success(insertRet.msg);
            loadData();
            setAllSettleDrawerVisible(false);
        } catch (e) {
            console.log("数据校验失败");
        }
    })
    const onCancel = () => {
        setAllSettleDrawerVisible(false);
    };

    return (
        <YHDrawer
            {...{
                title: "批量结算维修账单",
                width: 800,
                visible: allSettleDrawerVisible,
                onOk,
                onCancel,
                showFooter: true
            }}
        >
            <Table
                bordered
                columns={columns}
                dataSource={descRows}
                pagination={false}
            />
        </YHDrawer>
    )
}

